import CheckBoxIcon from '../../../../assets/checkbox-on@3x.png';
import React from 'react';
import classNames from 'classnames/bind';
import styles from './SquareCheckbox.module.scss';

const cx = classNames.bind(styles);

function SquareCheckbox({
  textElement,
  checked = false,
  disabled = false,
  onChange,
  containerStyle,
  checkboxStyle,
  textElementStyle,
}) {
  const renderEmptyCheckbox = () => <div className={cx('empty-checkbox')} />;
  const renderCheckbox = () => <img src={CheckBoxIcon} alt="checkbox" />;
  const renderDisabledCheckbox = () => (
    <img src={CheckBoxIcon} alt="disabled-checkbox" className={cx('disabled-checkbox')} />
  );

  return (
    <div className={cx('square-checkbox')} style={containerStyle}>
      <div
        className={cx('checkbox')}
        style={checkboxStyle}
        onClick={!disabled && onChange ? onChange : null}
      >
        {disabled ? renderDisabledCheckbox() : checked ? renderCheckbox() : renderEmptyCheckbox()}
      </div>
      <div
        className={cx('checkbox-label')}
        style={textElementStyle}
        onClick={!disabled && onChange ? onChange : null}
      >
        {textElement}
      </div>
    </div>
  );
}

export default SquareCheckbox;
